/** Approvals API endpoints, merged into the platform API client. */
export const approvalsApiEndpoints: Record<string, string> = {
  approvals: "/ext/approvals/requests/",
  askApproval: "POST:/ext/approvals/requests/",
  decideApproval: "POST:/ext/approvals/requests/:pk/:what/",
  // The platform's own: confirming it is really the signed-in person.
  confirmIdentity: "POST:/confirm-identity/",
  myPasskeys: "/passkeys/",
};
